import { useMemo } from "react";


export const useSubdomain = (position = 0) => useMemo(() => window?.location?.hostname?.split('.')[position], [ position ]);

export const useHostname = () => useMemo(() => window?.location?.hostname, []);
